
<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher un utilisateur..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openCreateModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
                </mat-card-subtitle>

    </mat-card-header>
<mat-card-content>
  <div class="method-steps-table">
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort>

  <!-- Select Column -->
  <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="toggleSelectAll()" [checked]="isAllStepsSelected"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let step">
            <mat-checkbox [checked]="selectedSteps.includes(step)" (change)="toggleSelection(step)"></mat-checkbox>
          </td>
        </ng-container>
  <!-- Code -->
  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
    <td mat-cell *matCellDef="let methode">{{ methode.code }}</td>
  </ng-container>

  <!-- Nom -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
    <td mat-cell *matCellDef="let methode">{{ methode.name }}</td>
  </ng-container>

  <!-- Norme -->
  <ng-container matColumnDef="norme">
    <th mat-header-cell *matHeaderCellDef>Norme</th>
    <td mat-cell *matCellDef="let methode">
      {{ methode.norme || '—' }}
    </td>
  </ng-container>

  <!-- Nombre de steps
  <ng-container matColumnDef="stepsCount">
    <th mat-header-cell *matHeaderCellDef>Étapes</th>
    <td mat-cell *matCellDef="let methode">
      {{ methode.stepIds?.length || 0 }}
    </td>
  </ng-container>

  <ng-container matColumnDef="versionsCount">
    <th mat-header-cell *matHeaderCellDef>Versions</th>
    <td mat-cell *matCellDef="let methode">
      {{ methode.versions?.length || 0 }}
    </td>
  </ng-container>
 -->
  <!-- Actions -->
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef class="text-center">
      Action
    </th>
    <td mat-cell *matCellDef="let methode">
      <div class="action-info text-center" style="justify-content: center !important;">
        <button mat-button matTooltip="Voir">
          <i class="material-symbols-outlined">visibility</i>
        </button>
      <!-- Bouton pour ouvrir le modal d'édition -->
<button mat-button matTooltip="Modifier" (click)="editMethode(methode)">
  <i class="material-symbols-outlined text-primary">brush</i>
</button>

        <button mat-button matTooltip="Supprimer" (click)="deleteMethode(methode)">
          <i class="material-symbols-outlined text-danger">delete</i>
        </button>
      </div>
    </td>
  </ng-container>

  <!-- Header & Rows -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <!-- No Data -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="8">
      Aucune méthode trouvée
    </td>
  </tr>

</table>


      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-card-content>

</mat-card>
<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Créer une Méthode</h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">

        <div class="row g-3">
          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-25">
                  <mat-label>Code</mat-label>
                  <input matInput formControlName="code" required>
                  <mat-error *ngIf="form.get('code')?.hasError('required')">Code requise</mat-error>
              </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-25">
                  <mat-label>Nom</mat-label>
                  <input matInput formControlName="name" required>
                  <mat-error *ngIf="form.get('name')?.hasError('required')">Nom requis</mat-error>
              </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-12">
              <mat-form-field class="mb-25">
                  <mat-label>Norme</mat-label>
                  <input matInput formControlName="norme">
              </mat-form-field>
          </div>
      </div>

  <!-- Étapes principales 
  <div class="mt-3">
    <label class="form-label fw-bold">Étapes disponibles</label>

    <div class="position-relative">
      <input
        type="text"
        class="form-control"
        placeholder="Sélectionner les étapes..."
        readonly
        (click)="toggleMainStepsDropdown()"
        [value]="getSelectedStepTitles(form.get('stepIds')?.value)"
      >

      <div
        *ngIf="mainStepsDropdownState"
        class="position-absolute bg-white border rounded w-100 shadow-sm"
        style="max-height: 200px; overflow-y: auto; z-index: 10;margin-left:5px;"
      >
        <div class="form-check p-2" *ngFor="let step of methodSteps; let idx = index">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="form.get('stepIds')?.value?.includes(step.id)"
            style="max-height: 200px; overflow-y: auto; z-index: 1000; margin-left: 5px;margin-right:5px"
            (change)="toggleStepSelectionCheckbox(step.id!, $event)"
            [id]="'mainStepDropdownCheckbox' + idx"
          >
          <label class="form-check-label" [for]="'mainStepDropdownCheckbox' + idx">
            {{ step.titre }}
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="form.get('stepIds')?.value?.length" class="mt-2">
      <strong>Sélectionné :</strong>
      <span class="badge bg-primary me-1 mb-1" *ngFor="let id of form.get('stepIds')?.value">
        {{ getStepTitleById(id) }}
      </span>
    </div>
  </div>

 <div formArrayName="versions" class="mt-4">

  <div
  *ngFor="let version of versions.controls; let i = index"
  [formGroupName]="i"
  class="version-card mb-4"
>


    <div class="version-header d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0 fw-semibold">Version {{ version.get('numero')?.value || (i + 1) }}</h6>

      <button
        mat-icon-button
        color="warn"
        (click)="removeVersion(i)"
        matTooltip="Supprimer la version"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="row g-3">

      <div class="col-sm-4">
        <label class="form-label">Numéro</label>
        <input type="number" class="form-control" formControlName="numero" required>
      </div>

      <div class="col-sm-4">
        <label class="form-label">Description</label>
        <input type="text" class="form-control" formControlName="description">
      </div>

      <div class="col-sm-4">
        <label class="form-label">Date d’édition</label>
        <input type="date" class="form-control" formControlName="dateEdition" required>
      </div>

      <div class="col-sm-12 mt-2">
        <label class="form-label">Étapes de la version</label>

        <div class="position-relative">
          <input
            type="text"
            class="form-control steps-input"
            placeholder="Sélectionner les étapes…"
            readonly
            (click)="toggleVersionDropdown(i)"
            [value]="getSelectedStepTitles(version.get('stepIds')?.value)"
          >

          <div
            *ngIf="versionDropdownState[i]"
            class="steps-dropdown"
          >
            <div
              class="form-check steps-option"
              *ngFor="let step of methodSteps"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="version.get('stepIds')?.value?.includes(step.id)"
                (change)="toggleStepSelection(step.id!, version.get('stepIds'))"
                [id]="'step_' + step.id + '_' + i"
              >
              <label class="form-check-label" [for]="'step_' + step.id + '_' + i">
                {{ step.titre }}
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="version.get('stepIds')?.value?.length" class="mt-2">
          <span
            class="badge bg-primary me-1 mb-1"
            *ngFor="let id of version.get('stepIds')?.value"
          >
            {{ getStepTitleById(id) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
-->

  <!-- Boutons enregistrer / annuler -->
  <div class="mt-4 d-flex justify-content-end">
    <button mat-flat-button color="primary" (click)="saveMethode()">
      Enregistrer
    </button>
  </div>

</form>

    </mat-card-content>
  </mat-card>
</ng-template>
<ng-template #editModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Modifier la Méthode</h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">

        <!-- Méthode principale -->
        <div class="row g-3">
          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-25">
                  <mat-label>Code</mat-label>
                  <input matInput formControlName="code" required>
                  <mat-error *ngIf="form.get('code')?.hasError('required')">Code requise</mat-error>
              </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-25">
                  <mat-label>Nom</mat-label>
                  <input matInput formControlName="name" required>
                  <mat-error *ngIf="form.get('name')?.hasError('required')">Nom requis</mat-error>
              </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-12">
              <mat-form-field class="mb-25">
                  <mat-label>Norme</mat-label>
                  <input matInput formControlName="norme">
              </mat-form-field>
          </div>
        </div>

        <!-- Étapes principales 
        <div class="mt-3">
          <label class="form-label fw-bold">Étapes disponibles</label>

          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Sélectionner les étapes..."
              readonly
              (click)="toggleMainStepsDropdown()"
              [value]="getSelectedStepTitles(form.get('stepIds')?.value)"
            >

            <div
              *ngIf="mainStepsDropdownState"
              class="position-absolute bg-white border rounded w-100 shadow-sm"
              style="max-height: 200px; overflow-y: auto; z-index: 10; margin-left:5px;"
            >
              <div class="form-check p-2" *ngFor="let step of methodSteps; let idx = index">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="form.get('stepIds')?.value?.includes(step.id)"
                  style="margin-left: 5px; margin-right: 5px;"
                  (change)="toggleStepSelectionCheckbox(step.id!, $event)"
                  [id]="'mainStepDropdownCheckbox' + idx"
                >
                <label class="form-check-label" [for]="'mainStepDropdownCheckbox' + idx">
                  {{ step.titre }}
                </label>
              </div>
            </div>
          </div>

          <div *ngIf="form.get('stepIds')?.value?.length" class="mt-2">
            <strong>Sélectionné :</strong>
            <span class="badge bg-primary me-1 mb-1" *ngFor="let id of form.get('stepIds')?.value">
              {{ getStepTitleById(id) }}
            </span>
          </div>
        </div>

        <div formArrayName="versions" class="mt-4">

  <div *ngFor="let version of versions.controls; let i = index" [formGroupName]="i" class="version-card mb-4">

    <div class="version-header d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0 fw-semibold">Version {{ version.get('numero')?.value || (i + 1) }}</h6>
      <button mat-icon-button color="warn" (click)="removeVersion(i)" matTooltip="Supprimer la version">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="row g-3">

      <div class="col-sm-4">
        <label class="form-label">Numéro</label>
        <input type="number" class="form-control" formControlName="numero" required>
      </div>

      <div class="col-sm-4">
        <label class="form-label">Description</label>
        <input type="text" class="form-control" formControlName="description">
      </div>

      <div class="col-sm-4">
        <label class="form-label">Date d’édition</label>
        <input type="date" class="form-control" formControlName="dateEdition" required>
      </div>

      <div class="col-sm-12 mt-2">
        <label class="form-label">Étapes de la version</label>

        <div class="position-relative">

          <input
            type="text"
            class="form-control steps-input"
            placeholder="Sélectionner les étapes…"
            readonly
            (click)="toggleVersionDropdown(i)"
            [value]="getStepTitlesFromIds(version.get('stepIds')?.value)"
          >

          <div *ngIf="versionDropdownState[i]" class="steps-dropdown position-absolute bg-white border rounded w-100 shadow-sm" style="max-height: 200px; overflow-y: auto; z-index: 10;">
            <div class="form-check steps-option" *ngFor="let step of methodSteps; let j = index">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="version.get('stepIds')?.value?.includes(step.id)"
                (change)="toggleStepSelection(step.id!, version.get('stepIds'))"
                [id]="'step_' + step.id + '_' + i"
              >
              <label class="form-check-label" [for]="'step_' + step.id + '_' + i">
                {{ step.titre }}
              </label>
            </div>
          </div>

        </div>

        <div *ngIf="version.get('stepIds')?.value?.length" class="mt-2">
          <span class="badge bg-primary me-1 mb-1" *ngFor="let id of version.get('stepIds')?.value">
            {{ getStepTitleById(id) }}
          </span>
        </div>

      </div>

    </div>
  </div>

  <div class="mt-4 text-end">
    <button mat-raised-button color="primary" class="add-version-btn" (click)="addVersion()">
      <mat-icon class="me-2">add_circle</mat-icon>
      Ajouter une version
    </button>
  </div>
</div>
-->

        <div class="mt-4 d-flex justify-content-end">
          <button mat-flat-button color="primary" (click)="saveEditedMethode()">
            Enregistrer
          </button>
        </div>

      </form>
    </mat-card-content>
  </mat-card>
</ng-template>
